import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_RISORSE_VERIFICA } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IRisorsaVerificaState extends EntityState<IID_RISORSE_VERIFICA, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_RISORSE_VERIFICA , realtimeEntity: 'IID_RisorseVerifica'})
@InterfaceDataStore(InterfaceName.IID_RISORSE_VERIFICA)
export class RisorseVerificaStore extends EntityStore<IRisorsaVerificaState> {
  constructor() {
    super();
  }
}
